(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.getElementById('buyers-premium-modal');
    if (!modal) return;

    var triggers = document.querySelectorAll('[data-buyers-premium-open]');
    if (!triggers.length) return;

    function setExpanded(open) {
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    function openModal() {
      modal.hidden = false;
      setExpanded(true);
      document.body.style.overflow = 'hidden';
      var okBtn = modal.querySelector('.sta-buyers-premium-modal__ok');
      if (okBtn) okBtn.focus();
    }

    function closeModal() {
      modal.hidden = true;
      setExpanded(false);
      document.body.style.overflow = '';
    }

    function closeModalFromEvent(e) {
      if (!e || e.target.hasAttribute('data-close')) closeModal();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal();
      });
    });

    modal.addEventListener('click', closeModalFromEvent);
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !modal.hidden) closeModal();
    });
  });
})();
